// core version + navigation, pagination modules:
import Swiper, { Pagination, Navigation } from "swiper";

export function postsCarousel() {
    Swiper.use([Pagination, Navigation]);

    // init Swiper:
    const postsCarousel = new Swiper(".posts-swiper", {
        // Optional parameters
        slidesPerView: 1,
        centeredSlides: true,

        // If we need pagination
        //pagination: {
        //    el: ".swiper-pagination",
        //    clickable: true,
        //},
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        breakpoints: {
            640: {
                slidesPerView: 2,
                slidesPerGroup: 2,
                spaceBetween: 20,
                centeredSlides: false,
            },
            768: {
                slidesPerView: 2,
                slidesPerGroup: 2,
                spaceBetween: 0,
                centeredSlides: false,
            },
            1024: {
                slidesPerView: 3,
                slidesPerGroup: 3,
                spaceBetween: 0,
                centeredSlides: false,
            },
        },
    });
}
